<div class="vflex-300">
  <h2>CSS Animations</h2>

  <h3>Fade</h3>
  <ng-template #fade data-sample="fade">
    <div class="vflex-200">
      <div class="vflex-100">
        <div>
          <button type="button" class="mdw-button mdw-primary" (click)="isFaded.set(!isFaded())">
            Click to toggle visibility
          </button>
        </div>
        <div class="fade-container">
          <mdw-fade [isVisible]="!isFaded()">
            <div class="surface-flat-outline overflow-hidden border-radius-100 pad-300 centered">
              <p>This content will fade in and out</p>
            </div>
          </mdw-fade>
        </div>
      </div>

      <div class="vflex-100">
        <div>
          <button
            type="button"
            class="mdw-button mdw-primary"
            (click)="slowFaded.set(!slowFaded())"
          >
            Click to toggle visibility slowly
          </button>
        </div>
        <div class="fade-container">
          <mdw-fade [isVisible]="!slowFaded()" [animationDuration]="3">
            <div class="surface-flat-outline overflow-hidden border-radius-100 pad-300 centered">
              <p>This content will fade in and out slowly</p>
            </div>
          </mdw-fade>
        </div>
      </div>

      <div class="vflex-100">
        <div>
          <button
            type="button"
            class="mdw-button mdw-primary"
            (click)="showPrimary.set(!showPrimary())"
          >
            Click to toggle content
          </button>
        </div>
        <div class="fade-container relative">
          <mdw-fade
            class="absolute"
            [style.top.px]="0"
            [style.left.px]="0"
            [deferEnter]="true"
            [isVisible]="showPrimary()"
          >
            <div class="surface-flat-outline overflow-hidden border-radius-100 pad-300 centered">
              <p>This is the primary content</p>
            </div>
          </mdw-fade>
          <mdw-fade
            class="absolute"
            [style.top.px]="0"
            [style.left.px]="0"
            [deferEnter]="true"
            [isVisible]="!showPrimary()"
          >
            <div class="surface-flat-outline overflow-hidden border-radius-100 pad-300 centered">
              <p>This is the replacement content</p>
            </div>
          </mdw-fade>
        </div>
      </div>

      <div class="vflex-100">
        <div>
          <button
            type="button"
            class="mdw-button mdw-primary"
            (click)="skipEnterFaded.set(!skipEnterFaded())"
          >
            Click to toggle visibility
          </button>
        </div>
        <div class="fade-container">
          <mdw-fade [isVisible]="!skipEnterFaded()" [skipEnterAnimation]="true">
            <div class="surface-flat-outline overflow-hidden border-radius-100 pad-300 centered">
              <p>This content will only fade out</p>
            </div>
          </mdw-fade>
        </div>
      </div>

      <div class="vflex-100">
        <div>
          <button
            type="button"
            class="mdw-button mdw-primary"
            (click)="skipLeaveFaded.set(!skipLeaveFaded())"
          >
            Click to toggle visibility
          </button>
        </div>
        <div class="fade-container">
          <mdw-fade [isVisible]="!skipLeaveFaded()" [skipLeaveAnimation]="true">
            <div class="surface-flat-outline overflow-hidden border-radius-100 pad-300 centered">
              <p>This content will only fade in</p>
            </div>
          </mdw-fade>
        </div>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="fade" sampleName="fade"></app-sample>

  <h3>Slide</h3>
  <ng-template #slide data-sample="slide">
    <div class="vflex-200">
      <div class="vflex-100">
        <div class="hflex-100 flex-align-items-center">
          <button
            type="button"
            class="mdw-button mdw-tertiary"
            [class.selected]="selectedItem() === 1"
            (click)="goToItem(1)"
          >
            Item 1
          </button>
          <button
            type="button"
            class="mdw-button mdw-tertiary"
            [class.selected]="selectedItem() === 2"
            (click)="goToItem(2)"
          >
            Item 2
          </button>
          <button
            type="button"
            class="mdw-button mdw-tertiary"
            [class.selected]="selectedItem() === 3"
            (click)="goToItem(3)"
          >
            Item 3
          </button>
        </div>
        <div class="fade-container border-radius-100 overflow-hidden relative border-muted">
          @for (item of items(); track item.id) {
            <mdw-slide [isActive]="selectedItem() === item.id" [direction]="navDir()">
              <div
                class="fill-height fill-width hflex-000 flex-align-items-center flex-justify-content-center"
              >
                <p>{{ item.label }}</p>
              </div>
            </mdw-slide>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="slide" sampleName="slide"></app-sample>

  <h3>Collapse</h3>
  <ng-template #collapse data-sample="collapse">
    <div class="vflex-100">
      <div class="surface-flat-outline overflow-hidden border-radius-100">
        <button
          type="button"
          class="surface-muted fill-width pad-300"
          (click)="isCollapsed.set(!isCollapsed())"
        >
          Click to collapse
        </button>

        <mdw-collapse [isCollapsed]="isCollapsed()">
          <div class="fill-width pad-300 centered">
            <p>This content will be collapsed</p>
          </div>
        </mdw-collapse>
      </div>

      <div class="surface-flat-outline overflow-hidden border-radius-100">
        <button
          type="button"
          class="surface-muted fill-width pad-300"
          (click)="slowCollapsed.set(!slowCollapsed())"
        >
          Click to collapse
        </button>

        <mdw-collapse [isCollapsed]="slowCollapsed()" [animationDuration]="3">
          <div class="fill-width pad-300 centered">
            <p>This content will be collapsed slowly</p>
          </div>
        </mdw-collapse>
      </div>

      <div class="surface-flat-outline overflow-hidden border-radius-100">
        <button
          type="button"
          class="surface-muted fill-width pad-300"
          (click)="delayedCollapsed.set(!delayedCollapsed())"
        >
          Click to collapse
        </button>

        <mdw-collapse [isCollapsed]="delayedCollapsed()" [animationEnterDelay]="3">
          <div class="fill-width pad-300 centered">
            <p>This collapse will be delayed</p>
          </div>
        </mdw-collapse>
      </div>

      <div class="surface-flat-outline shrink-wrap hflex-000 overflow-hidden border-radius-100">
        <button
          type="button"
          class="surface-muted fill-height pad-300"
          (click)="horizontalCollapsed.set(!horizontalCollapsed())"
        >
          Click to collapse
        </button>

        <mdw-collapse orientation="horizontal" [isCollapsed]="horizontalCollapsed()">
          <div class="fill-width pad-300 centered overflow-hidden">
            <p class="overflow-text-ellipses">This content will collapse</p>
          </div>
        </mdw-collapse>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="collapse" sampleName="collapse"></app-sample>

  <h2>Rive Animations</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>import &#123; RiveComponent &#125; from '&#64;spaces-ui/animations/rive';</code>
  </div>
  <h3>Rive Animations (click to play)</h3>
  <ng-template #rive1 data-sample="rive1">
    <div class="vflex-100">
      @for (option of data; track $index) {
        <div
          class="hflex-300 flex-align-items-center border-radius-100 option-container"
          [class.hover]="option.hasHover"
          (mouseenter)="handleMouseEnter(option)"
          (mouseleave)="handleMouseLeave(option)"
          (click)="animateOption(option)"
        >
          <div class="pad-200 fill-flex">{{ option.label }}</div>
          @if (option.hasHover || option.state === checkboxAnimationConfig.states.Checked) {
            <mdw-rive
              [fileName]="checkboxAnimationConfig.fileName"
              [artboardName]="checkboxAnimationConfig.artboardName"
              [stateMachineName]="checkboxAnimationConfig.stateMachineName"
              [inputName]="checkboxAnimationConfig.inputName"
              [state]="option.state"
            ></mdw-rive>
          }
        </div>
      }
    </div>
  </ng-template>
  <app-sample [sampleContent]="rive1" sampleName="rive1"></app-sample>
</div>
